import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AI_AREAS, resolveArea } from './areas';
import AiAreaNav from './Components/AiAreaNav';

/**
 * AI Admin — where the assistant is configured.
 *
 * A shell, not a page. It owns four things and nothing else:
 *
 *   1. the "AI Admin" eyebrow above whichever area is open;
 *   2. THE PAGE'S <h1>, which is the open area's label;
 *   3. the section selector across the registered areas (AiAreaNav);
 *   4. the mapping from the URL segment to an area component.
 *
 * Everything else belongs to the area. Adding a second or third AI function
 * — prompt editing, model settings, an extraction playground — is ONE entry
 * in ./areas.js plus its component; this file does not change. See the
 * comment at the top of ./areas.js, which is the extension point.
 *
 * THE HEADING MOVED HERE, and that is a deliberate change of contract. Each
 * area used to render its own hero <h1> repeating a string that ./areas.js
 * already held — two copies of the same words, and the nav sat ABOVE the
 * heading it labelled, which reads as a nav for the whole app rather than a
 * selector within one page. Now: eyebrow, heading, selector, area. An area
 * must therefore NOT render an <h1>; there is exactly one per page and this
 * file owns it.
 *
 * ROUTING: /ai-admin/<key> is the real address of an area, so every area is
 * deep-linkable and bookmarkable from the day it is added. Bare /ai-admin
 * lands on the first registered area (Routes.jsx registers both shapes
 * against this component), which is what makes a single-area AI Admin feel
 * like a page rather than an empty container.
 */
function AiAdmin() {
  const { area: areaKey } = useParams();
  const navigate = useNavigate();

  const active = resolveArea(areaKey);
  const { Component } = active;

  return (
    <div className="ai-admin">
      <div className="ai-admin-kicker">
        <i className="fa fa-wand-magic-sparkles me-2" aria-hidden="true" />
        AI Admin
      </div>

      {/* The one <h1> on the page, and it is the area's own label from
          ./areas.js — not a second copy of it written out in the area. */}
      <h1 className="ai-admin-title">{active.label}</h1>

      <AiAreaNav
        areas={AI_AREAS}
        activeKey={active.key}
        onSelect={(key) => navigate(`/ai-admin/${key}`)}
      />

      <Component />
    </div>
  );
}

export default AiAdmin;
